import React from 'react'
import PropTypes from 'prop-types';

import { DropdownButton, MenuItem } from 'react-bootstrap'
import { ListItem } from '~/views'

import style from './style.css'

export default class NetworkItem extends React.Component {
  
  static REMOVE_EVENT = 'removeNetwork';

  static TRANSFER_EVENT = 'transferNetwork'

  static propTypes = {
    item : PropTypes.object.isRequired,
    onEvent : PropTypes.func,
    selected : PropTypes.bool
  }

  onEvent( event ) {
    if ( this.props.onEvent ) { 
      this.props.onEvent( event, this.props.item );
    }
  }

  render() {
    const network = this.props.item;
    return (
      <ListItem className={style.networkItem} 
        onEvent={this.props.onEvent}
        item={network}
        selected={this.props.selected}
        title={network.name}
        subtitle={network.id}
        leftView={this.renderLeft( network )}
        rightView={this.renderRight( network )} />
    )
  }

  renderLeft() {
    return null;
  }

  renderRight( network ) {

    return (
      <div>
        <DropdownButton pullRight bsStyle="link" title={<i className="fa fa-gear fa-lg fa-fw" />} key={network.id} id={`options-${network.id}`}>
          {/* 
          <MenuItem bsStyle="link" bsSize="large" className={style.pause} 
           onClick={()=>{this.onEvent( NetworkItem.TRANSFER_EVENT )}} > 
          <i className="fa fa-paper-plane-o fa-fw"></i> Transfer
        </MenuItem>
        <MenuItem divider />
       */}
          <MenuItem bsStyle="link"
            bsSize="large"
            className={style.pause} 
            onClick={() => { this.onEvent( NetworkItem.REMOVE_EVENT ) }}> 
            <i className="fa fa-times-circle fa-fw" />
            {' '}
            Remove
          </MenuItem>
        </DropdownButton>

      </div>
    )
  }

}
